import { render, staticRenderFns } from "./UtPhotoProfile.vue?vue&type=template&id=4770815f"
import script from "./UtPhotoProfile.vue?vue&type=script&lang=js"
export * from "./UtPhotoProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports